import { Box, Button, Card, CircularProgress, Divider, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { CALENDAR_COLORS, formatDate, getClassTitle, Icons } from '../../utils/utilities'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from '@emotion/styled'
import dayjs from 'dayjs'

import AddQuizFromClassDialog from '../exams-components/quiz-questionbank/class-quizzes/AddQuizFromClassDialog'
import { useQuizAndQuestionbankStore } from '../../store/quiz.store'
import { useRoomStore } from '../../store/room.store'
import { useUserStore } from '../../store/user.store'
import noClassesImg from '../../assets/noclasses.svg'
import api from '../../service/api'
import { observer } from 'mobx-react'
import CountBadge from '../common/CountBadge'
import DataLoadingSpinner from '../common/DataLoadingSpinner'
import CustomChip from '../common/CustomChip'
import { getTransformedMeetingType } from '../../utils/meeting-utilities'
import HybridClassStartOptionsDialog from './HybridClassStartOptionsDialog'
import ConflictingClassSessionDetailsDrawer from './ConflictingClassSessionDetailsDrawer'
import { useSettingsStore } from '../../store/settings.store'

const sortRooms = ( rooms ) => {
    try {
        const sortedRooms = rooms.sort( ( a, b ) => {
            const refDate = formatDate( new Date(), { format: "YYYY-MM-DD" } )
            const normalizeTime = ( room ) => {

                if ( "meeting_type" in room && room.starts_at ) {

                    return new Date( room.starts_at ).getTime()
                } else if ( room.sTime ) {
                    // Normalize by attaching today's date and parsing consistently
                    const isoString = `${refDate}T${room.sTime}` // enforce ISO format

                    return new Date( isoString ).getTime()
                }
                return Infinity // fallback for invalid data
            }
            return normalizeTime( a ) - normalizeTime( b )
        } )
        return sortedRooms
    } catch ( err ) {
        console.log( err )
        return rooms
    }
}

const ClassButton = styled( Button )( ( { theme } ) => ( {
    minWidth: "initial",
    textTransform: "capitalize",
    background: theme.palette.common.font + "22",
    border: `1px solid ${theme.palette.common.font + "11"}`,
    color: theme.palette.common.font,
    "&:hover": {
        background: theme.palette.common.font + "44",
        borderColor: theme.palette.common.font + "22",
    },
} ) )

const ClassesCard = observer( () => {

    const [selectedHybridClassToStart, setSelectedHybridClassToStart] = useState( null )
    const [createNewQuizDialogState, setCreateNewQuizDialogState] = useState( false )
    const [roomSelectedForQuiz, setRoomSelectedForQuiz] = useState( null )
    const [checkingConflictForId, setCheckingConflictForId] = useState( null )
    const [conflictingSessionDetails, setConflictingSessionDetails] = useState( null )
    const [selectedDateDetails, setSelectedDateDetails] = useState( {
        day: dayjs(),
        erpDate: dayjs().format( "YYYY-MM-DD" ),
        indianDisplayFormat: dayjs().format( "DD-MM-YYYY" ),
        cardDisplayFormat: dayjs().format( "LL" ),
        tense: {
            isToday: true,
            isFuture: false,
        }
    } )
    const [meetingsFetchError, setMeetingsFetchError] = useState( null )
    const [meetings, setMeetings] = useState( [] )
    const [loading, setLoading] = useState( true )
    const [ending] = useState( false )

    const { palette, shadows, border } = useTheme()
    const navigate = useNavigate()

    const QuizStore = useQuizAndQuestionbankStore()
    const SettingsStore = useSettingsStore()
    const RoomStore = useRoomStore()
    const UserStore = useUserStore()

    const recentDays = useMemo( () => {
        const today = dayjs()
        const recentDaysData = {}
        recentDaysData[today.format( "DD-MM-YYYY" )] = "Today"
        recentDaysData[today.add( 1, 'day' ).format( "DD-MM-YYYY" )] = "Tomorrow"
        recentDaysData[today.subtract( 1, 'day' ).format( "DD-MM-YYYY" )] = "Yesterday"
        return recentDaysData
    }, [] )


    const getClassBoxDesigns = ( room, type = "erp-class" ) => {
        const designs = {}
        const { isFuture, isToday } = selectedDateDetails.tense
        if ( type === "erp-class" ) {
            // designs.border = isFuture ? !room.online ? `2px solid ${CALENDAR_COLORS.offlineBorder}` : `2px solid ${CALENDAR_COLORS.onlineBorder}` : "none"
            designs.opacity = ( isFuture || isToday ) ? 1 : 0.7
            designs.boxShadow = ( isFuture || isToday ) ? shadows[3] : shadows[0]
            designs.boxBorderRadius = isFuture ? "0" : "0 0 10px 10px"
            designs.bg = palette.contentBg
            // designs.bg = ( isFuture || isToday ) ? !room.online ? CALENDAR_COLORS.offlineDark : CALENDAR_COLORS.onlineDark : palette.grey[800]
            designs.color = "#fff"
            designs.timeBg = ( isFuture || isToday ) ? !room.online ? CALENDAR_COLORS.offlineLight : CALENDAR_COLORS.onlineLight : "#fff"
        } else {
            // designs.border = isFuture ? `2px solid ${CALENDAR_COLORS.onlineBorder}` : "none"
            designs.opacity = ( isFuture || isToday ) ? 1 : 0.7
            designs.boxShadow = ( isFuture || isToday ) ? shadows[3] : shadows[0]
            designs.boxBorderRadius = isFuture ? "0" : "0 0 10px 10px"
            designs.bg = palette.contentBg
            // designs.bg = ( isFuture || isToday ) ? CALENDAR_COLORS.onlineDark : palette.grey[200]
            designs.color = "#fff"
            designs.timeBg = ( isFuture || isToday ) ? CALENDAR_COLORS.onlineLight : "#fff"
        }
        return designs
    }

    const checkTime = ( sTime, eTime ) => {
        // if ( UserStore.getUser.user_id === 'AI002432' ) {
        //     return true

        // } else {
        var currentDate = new Date()
        var currentTime = currentDate.toString().split( " " )[4]
        var sTimeSplit = sTime.split( ":" )
        var eTimeSplit = eTime.split( ":" )
        var cTimeSplit = currentTime.split( ":" )
        var sTimeHr = parseInt( sTimeSplit[0] ), sTimeMin = parseInt( sTimeSplit[1] )
        var eTimeHr = parseInt( eTimeSplit[0] ), eTimeMin = parseInt( eTimeSplit[1] )
        var cTimeHr = parseInt( cTimeSplit[0] ), cTimeMin = parseInt( cTimeSplit[1] )
        var startMin = 0, endMin = 0, currentMin = 0
        if ( sTimeHr === 0 ) {
            startMin = sTimeMin
        } else if ( sTimeHr > 0 ) {
            startMin = ( ( 60 * sTimeHr ) + sTimeMin )
        }
        if ( eTimeHr === 0 ) {
            endMin = eTimeMin
        } else if ( eTimeHr > 0 ) {
            endMin = ( ( 60 * eTimeHr ) + eTimeMin )
        }
        if ( cTimeHr === 0 ) {
            currentMin = cTimeMin
        } else if ( cTimeHr > 0 ) {
            currentMin = ( ( 60 * cTimeHr ) + cTimeMin )
        }

        if ( currentMin >= ( startMin - 15 ) && currentMin <= endMin ) {
            return true
        }
        else {
            return false
        }
        // }
    }

    const endSession = async ( roomDetails ) => {
        try {
            const meetingId = meetings.find( meeting => meeting.time_table_id === roomDetails.time_table_id )
            if ( !meetingId )
                return
            await api.onlineMeetings.endMeeting( meetingId.id )
        } catch ( err ) {
            toast( err?.response?.data?.message || "Failed to end the session, please try again." )
        }
    }

    const generateClassMeetingSessionAndStart = async ( roomDetails, options = {} ) => {
        try {

            if ( roomDetails?.does_exists ) {
                if ( roomDetails.does_exists?.meeting_type === "hybrid-class" ) {
                    if ( UserStore.getUser.user_role === "STUDENT" ) {
                        return navigate( `/student/hybrid-class/${roomDetails?.does_exists.id}` )
                    }
                    return navigate( `/faculty/hybrid-class/${roomDetails?.does_exists.id}` )
                } else {
                    if ( UserStore.getUser.user_role === "STUDENT" )
                        return window.open( `/class/${roomDetails?.does_exists.id}` )
                    return navigate( `/faculty/class/${roomDetails?.does_exists.id}` )
                }
            }

            if ( !UserStore.getUser.empcode && UserStore.getUser.user_role === "STUDENT" ) {
                if ( roomDetails.mode !== "hybrid" || options?.meeting_type === 'class' ) {
                    if ( roomDetails["sTime"] === undefined || roomDetails["sTime"] === null || roomDetails["eTime"] === undefined || roomDetails["eTime"] === null ) {
                        toast.error( "ERP not sending Start Time / End Time" )
                        return
                    } else if ( checkTime( roomDetails["sTime"], roomDetails["eTime"] ) === false ) {
                        toast.error( `You can only join online class from ${roomDetails["sTime"].substring( 0, 5 )} to ${roomDetails["eTime"].substring( 0, 5 )}` )
                        return
                    }
                }

                const meeting = meetings.find( meeting => meeting.time_table_id === roomDetails.time_table_id )
                if ( !meeting ) {
                    const { data: { data: meeting } } = await api.onlineMeetings.fetchClassMeeting( roomDetails.time_table_id )

                    if ( meeting.meeting_type === "hybrid-class" )
                        return navigate( `/student/hybrid-class/${meeting.id}` )
                    window.open( `/class/${meeting.id}` )

                } else {

                    if ( meeting.meeting_type === "hybrid-class" )
                        return navigate( `/student/hybrid-class/${meeting.id}` )

                    window.open( `/class/${meeting.id}` )
                }
            } else {
                if ( roomDetails.mode !== "hybrid" || options?.meeting_type === 'class' ) {
                    if ( roomDetails["sTime"] === undefined || roomDetails["sTime"] === null || roomDetails["eTime"] === undefined || roomDetails["eTime"] === null ) {
                        toast.error( "ERP not sending Start Time / End Time" )
                        return
                    } else if ( checkTime( roomDetails["sTime"], roomDetails["eTime"] ) === false ) {
                        toast.error( `You are only permitted to start the online class from ${roomDetails["sTime"].substring( 0, 5 )} to ${roomDetails["eTime"].substring( 0, 5 )}` )
                        return
                    }
                }

                const meeting = meetings.find( meeting => meeting.time_table_id === roomDetails.time_table_id )
                if ( !meeting ) {

                    if ( dayjs( `${roomDetails.selected_date}T${roomDetails.eTime}` ).isBefore( dayjs() ) ) {
                        if ( !dayjs( `${roomDetails.selected_date}T${roomDetails.eTime}` ).isSame( dayjs(), 'day' ) )
                            return toast.error( "Class can only be started for the selected date." )
                    }

                    delete roomDetails.status
                    roomDetails.record = false
                    let groupTitle
                    if ( roomDetails.batch_short_name !== "NA" ) {
                        groupTitle = `${roomDetails.course_branch_short_name}-${roomDetails.course_branch_short_name || ""}${roomDetails.current_year ? ` Y${roomDetails.current_year}` : ``}${roomDetails.current_sem ? ` S${roomDetails.current_sem}` : ``} (${roomDetails.section_short_name + ")"}`
                    } else {
                        groupTitle = `${roomDetails.batch_short_name}-${roomDetails.course_branch_short_name || ""}${roomDetails.current_year ? ` Y${roomDetails.current_year}` : ``}${roomDetails.current_sem ? ` S${roomDetails.current_sem}` : ``}`
                    }
                    const onlineClassPayload = {
                        title: getClassTitle( roomDetails ),
                        starts_at: dayjs( `${roomDetails.selected_date}T${roomDetails.sTime}` ),
                        ends_at: dayjs( `${roomDetails.selected_date}T${roomDetails.eTime}` ),
                        hosts: [],
                        selected_student_groups: [roomDetails ? roomDetails.batch_short_name !== "NA" ?
                            { title: groupTitle, course_name_short: roomDetails.course_name_short, current_sem: roomDetails.current_sem, current_year: roomDetails.current_year, id: String( roomDetails.batch_assignment_id ), batch_short_name: roomDetails.batch_short_name, batch_assignment_id: roomDetails.batch_assignment_id, branch_name: roomDetails.branch_name, branch_id: roomDetails.branch_id } :
                            { title: groupTitle, course_branch_short_name: roomDetails.course_branch_short_name, current_sem: roomDetails.current_sem, current_year: roomDetails.current_year, id: `${roomDetails.section_assignment_id}-${roomDetails.section_short_name}`, section_assignment_id: roomDetails.section_assignment_id, section_short_name: roomDetails.section_short_name, branch_name: roomDetails.branch_name, branch_id: roomDetails.branch_id } : '-',],
                        added_users: [],
                        added_users_emails: [],
                        batch_groups_selected: roomDetails.batch_short_name !== "NA" ? 1 : 0,
                        section_groups_selected: roomDetails.batch_short_name !== "NA" ? 0 : 1,
                        selectedAcYear: null,
                        meeting_type: options?.meeting_type || "class",
                        meeting_settings: {
                            access_type: 'SPECIFIED_GROUPS_AND_USERS',
                            any_one_can_join_with_pass_key: false,
                            enable_chats: options?.meeting_type !== 'class' ? false : true,
                            enable_screen_sharing: false,
                            enable_microphone: false,
                            enable_video_feed: false,
                            join_without_host: false,
                            enable_reactions: options?.meeting_type !== 'class' ? false : true,
                            ...( options?.settings || {} )
                        },
                        time_table_id: roomDetails.time_table_id,
                        time_table_class_details: roomDetails
                    }
                    try {
                        const { data: { data: newRoom } } = await api.onlineMeetings.createMeeting( onlineClassPayload )
                        const { data: { data: meetings } } = await api.onlineMeetings.fetchMeetings()
                        setMeetings( meetings )

                        if ( newRoom.meeting_type === "hybrid-class" )
                            return navigate( `/faculty/hybrid-class/${newRoom.id}` )
                        window.open( `/${newRoom.meeting_type === "hybrid-class" ? 'hybrid-class' : 'class'}/${newRoom.id}` )

                    } catch ( err ) {
                        if ( err?.response?.data?.alreadyExists ) {

                            const meeting = err?.response?.data?.data

                            if ( meeting.meeting_type === "hybrid-class" )
                                return navigate( `/faculty/hybrid-class/${meeting?.id}` )

                            window.open( `/${meeting.meeting_type === "hybrid-class" ? 'hybrid-class' : 'class'}/${meeting?.id}` )
                        } else {
                            toast( err?.response?.data?.message || "Failed to start the class, please try again." )
                        }
                    }
                } else {
                    if ( meeting.meeting_type === "hybrid-class" )
                        return navigate( `/faculty/hybrid-class/${meeting.id}` )
                    window.open( `/${meeting.meeting_type === "hybrid-class" ? 'hybrid-class' : 'class'}/${meeting.id}` )
                }
            }
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Failed to join the class." )
        }
    }

    const showStartClassOptions = async ( room ) => {
        try {
            if ( !room.hybrid )
                return generateClassMeetingSessionAndStart( room, { meeting_type: 'class' } )

            setCheckingConflictForId( room.time_table_id )
            const { data: { data: conflictDetails } } = await api.onlineMeetings.checkConflictingClassSession( room.time_table_id )

            if ( conflictDetails?.conflict_found ) {
                setConflictingSessionDetails( conflictDetails )
                return
            }

            setSelectedHybridClassToStart( room )
        } catch ( err ) {
            toast( err?.response?.data?.message || "Something went wrong while checking for conflicting sessions." )
        } finally {
            setCheckingConflictForId( null )
        }
    }


    const moveDateBy = offset => {
        setSelectedDateDetails( prev => {
            const newDay = prev.day.add( offset, 'days' )
            return {
                day: newDay,
                erpDate: newDay.format( "YYYY-MM-DD" ),
                indianDisplayFormat: newDay.format( "DD-MM-YYYY" ),
                cardDisplayFormat: newDay.format( "LL" ),
                tense: {
                    isToday: newDay.format( "DD-MM-YYYY" ) === dayjs().format( "DD-MM-YYYY" ),
                    isFuture: newDay > dayjs()
                }
            }
        } )
    }

    const setTodayAsSelected = () => {
        setSelectedDateDetails( {
            day: dayjs(),
            erpDate: dayjs().format( "YYYY-MM-DD" ),
            indianDisplayFormat: dayjs().format( "DD-MM-YYYY" ),
            cardDisplayFormat: dayjs().format( "LL" ),
            tense: {
                isToday: true,
                isFuture: false,
            }
        } )
    }

    const getClasses = useCallback( async ( refresh = false ) => {
        if ( QuizStore.getErrors.classQuizzes )
            await QuizStore.fetchClassAssociatedQuizInstances()
        if ( refresh || !Boolean( RoomStore.getRooms[selectedDateDetails.erpDate] ) ) {
            setLoading( true )
            await RoomStore.fetchRooms( selectedDateDetails.erpDate )
        }
        setLoading( false )
    }, [RoomStore, selectedDateDetails, QuizStore] )

    const fetchMeetings = useCallback( async () => {
        try {
            const { data: { data: meetings } } = await api.onlineMeetings.fetchMeetings()
            setMeetings( meetings )
            setMeetingsFetchError( null )
        } catch ( err ) {
            setMeetingsFetchError( {
                message: err?.response?.data?.message || "Failed to fetch meetings.",
                code: err?.response?.status
            } )
        }
    }, [] )

    useEffect( () => {
        getClasses()
        fetchMeetings()
    }, [getClasses, fetchMeetings] )

    const sortedRooms = sortRooms( [...RoomStore.getRooms[selectedDateDetails.erpDate] || [], ...meetings.filter( m => m.date === selectedDateDetails.erpDate )] )

    return (
        <Box gridArea="cc" minHeight="400px" display="flex" flexDirection="column">

            {Boolean( selectedHybridClassToStart ) && <HybridClassStartOptionsDialog onQuizDialogOpen={() => setRoomSelectedForQuiz( selectedHybridClassToStart )} onStart={async ( options ) => await generateClassMeetingSessionAndStart( selectedHybridClassToStart, options )} open={Boolean( selectedHybridClassToStart )} setOpen={setSelectedHybridClassToStart} room={selectedHybridClassToStart} />}

            {roomSelectedForQuiz && <AddQuizFromClassDialog fetchQuizzesInstances={() => getClasses( true )} createMode={createNewQuizDialogState} setCreateMode={setCreateNewQuizDialogState} state={Boolean( roomSelectedForQuiz )} room={roomSelectedForQuiz} setState={setRoomSelectedForQuiz} />}

            {Boolean( conflictingSessionDetails ) && <ConflictingClassSessionDetailsDrawer open={Boolean( conflictingSessionDetails )} onClose={() => setConflictingSessionDetails( null )} details={conflictingSessionDetails} />}


            <Box height="25px" display="flex" marginBottom="5px" gap="10px" alignItems="center">
                <Typography display="flex" gap="5px" alignItems="center" variant='subtitle2' component="h3" flexGrow={1}>
                    <Typography component="span" display="flex" alignItems="center" color='primary'>{Icons.default.Calendar}</Typography>
                    {recentDays[selectedDateDetails.indianDisplayFormat] ? `${recentDays[selectedDateDetails.indianDisplayFormat]}'s  classes and meetings` : `Schedules for ${selectedDateDetails.cardDisplayFormat}`}
                    {sortedRooms?.length > 0 && <CountBadge value={sortedRooms?.filter( room => !( 'meeting_type' in room ) || !room.meeting_type.includes( 'class' ) ).length} />}
                </Typography>

                <Box display="flex" alignItems="center">
                    <IconButton onClick={() => moveDateBy( -1 )} sx={{ fontSize: "16px" }} size='small'>
                        {Icons.default.ChevronLeftIcon}
                    </IconButton>
                    <Tooltip title="Go To Today" >
                        <Box component="span">
                            <IconButton disabled={recentDays[selectedDateDetails.indianDisplayFormat] === "Today"} onClick={setTodayAsSelected} sx={{ fontSize: "16px" }} size='small'>
                                {Icons.default.Calendar}
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <IconButton onClick={() => moveDateBy( 1 )} sx={{ fontSize: "16px" }} size='small'>
                        {Icons.default.ChevronRightIcon}
                    </IconButton>
                </Box>
            </Box>

            <Card elevation={0} sx={{ flexGrow: 1 }}>
                {!loading && sortedRooms?.length > 0 && <Box padding="5px">
                    {sortedRooms.map( ( room, tindex ) => {

                        if ( 'meeting_type' in room ) {
                            if ( room.meeting_type === 'class' )
                                return null
                            if ( room.meeting_type === 'hybrid-class' )
                                return null
                            const meeting = room
                            const classBoxDesigns = getClassBoxDesigns( meeting, "meeting" )
                            return (
                                <Box
                                    marginBottom="10px"
                                    position="relative"
                                    flexShrink={0}
                                    bgcolor={palette.contentBg}
                                    borderRadius="5px"
                                    key={tindex}
                                    border={border[1]}
                                    overflow="hidden"
                                >
                                    <Box padding="5px" borderRadius={classBoxDesigns.boxBorderRadius} >
                                        <Box display="flex" flexWrap="wrap" gap="5px">
                                            <CustomChip variant='gradient' textStyles={{ textTransform: "capitalize" }} color="white" value={meeting.meeting_type} />
                                            {meeting.ended && <CustomChip color="error" value="Ended" tooltipTitle={`Ended at: ${formatDate( meeting.ends_at, { format: "hh:mm A" } )}`} />}
                                        </Box>
                                        <Tooltip title={meeting.title}>
                                            <Typography noWrap gutterBottom variant='subtitle2' color='textPrimary' component="h3" sx={{ textTransform: "capitalize" }}>{meeting.title}</Typography>
                                        </Tooltip>
                                        <Box display="flex" flexWrap="wrap" gap="5px" alignItems="center">
                                            {UserStore?.getUser?.user_role !== 'STUDENT' && ( meeting?.creator_data?.name?.toLowerCase() || meeting?.creator_data?.empcode ) && <CustomChip textStyles={{ textTransform: "capitalize" }} startIcon={Icons.default.User} value={meeting?.creator_data?.name?.toLowerCase() || meeting?.creator_data?.empcode} />}
                                            <CustomChip tooltipTitle={getTransformedMeetingType( meeting.meeting_type, { forDisplay: true } )} startIcon={Icons.default.Clock} value={`${formatDate( meeting.starts_at, { format: "hh:mm A" } )} - ${formatDate( meeting.ends_at, { format: "hh:mm A" } )}`} />
                                        </Box>

                                        <Divider sx={{ margin: "10px 0 5px 0" }} />

                                        <Box display="flex" marginTop="10px" justifyContent="flex-start" alignItems="center" gap="5px">
                                            {!meeting.ended && <Link target='_blank' to={`/${["webinar", "class"].includes( room.meeting_type ) ? room.meeting_type : "meeting"}/${room.id}`} >
                                                <ClassButton startIcon={Icons.default.Login} disabled={selectedDateDetails.tense?.isFuture} size="small" >
                                                    Join
                                                </ClassButton>
                                            </Link>}
                                            {!["STUDENT"].includes( UserStore.getUser.user_role ) && <Link to={`/faculty/${getTransformedMeetingType( meeting.meeting_type )}/${room.id}`} >
                                                <ClassButton startIcon={Icons.default.Info} size="small" >
                                                    Open details
                                                </ClassButton>
                                            </Link>}
                                        </Box>

                                    </Box>
                                </Box>
                            )
                        } else if ( !( 'meeting_type' in room ) ) {

                            const classBoxDesigns = getClassBoxDesigns( room )
                            room.does_exists = meetings.find( meeting => meeting.time_table_id === room.time_table_id )

                            room.mode = room.online ? "online" : "offline"

                            const subject = UserStore.getUserSubjectsDetails?.currentSubjects?.find( sub => +sub.subject_id === +room.subject_id )
                            room.course_code = room.course_code || subject?.subject_code || "NA"
                            room.course_name = room.course_name || subject?.subject_name || "NA"

                            if ( room.online ) {
                                // const hybridModeAllowed = Boolean( room?.is_hybrid_course ) || ( SettingsStore?.getUseSettings['hybrid_class_subjects_codes'] || [] ).includes( room.course_code )
                                const hybridModeAllowed = Boolean( room?.is_hybrid_course )
                                room.mode = hybridModeAllowed ? "hybrid" : room.mode
                            }

                            room.hybrid = room.mode === "hybrid"

                            if ( room?.does_exists ) {
                                room.mode = room?.does_exists?.meeting_type === 'hybrid-class' ? "hybrid" : room?.does_exists?.meeting_type === 'class' ? "online" : room.mode
                            }


                            const modeTagColor = room.mode === "online" ? palette.success.main : room.mode === "offline" ? palette.customThemeColor.main : palette.common.white
                            const modeTagBgcolor = room.mode === "online" ? palette.contentBg : room.mode === "offline" ? palette.contentBg : `linear-gradient(125.39deg, #708090 -32.54%, #E9967A 110.4%)`


                            return (
                                <Box
                                    marginBottom="5px"
                                    position="relative"
                                    bgcolor={palette.contentBg}
                                    sx={{
                                        border: border[1],
                                        ":before": {
                                            content: '""',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            borderRadius: '5px',
                                            pointerEvents: 'none',
                                        },
                                    }}
                                    flexShrink={0}
                                    borderRadius="5px"
                                    // bgcolor={palette.contentBg}
                                    key={tindex}
                                    overflow="hidden"
                                >
                                    <Box padding="10px" borderRadius={classBoxDesigns.boxBorderRadius} >
                                        <Box display="flex" gap="5px" alignItems="center">
                                            {QuizStore.getClassQuizzes[room.time_table_id]?.length > 0 && <Typography fontSize="10px" bgcolor={palette.primary.dark} width="fit-content" color={palette.primary.contrastText} borderRadius="5px" padding="2px 5px">QUIZ</Typography>}
                                            {<Typography position={{ sm: "static", md: "absolute" }} top="10px" right="5px" fontSize="10px" fontWeight={600} gap="5px" display="flex" alignItems="center" width="fit-content" border={`1px solid ${modeTagColor}`} color={modeTagColor} borderRadius="5px" padding="2px 5px" sx={{ background: modeTagBgcolor, textTransform: "capitalize" }}>
                                                {room?.does_exists ? room?.does_exists?.meeting_type === 'hybrid-class' ? "Hybrid" : room?.does_exists?.meeting_type === 'class' ? "Online" : room.mode : room.mode === "hybrid" ? "Online/Hybrid" : room.mode}
                                            </Typography>}
                                        </Box>
                                        <Box display="flex" gap="5px" alignItems="center" flexWrap="wrap">
                                            <Typography noWrap variant='subtitle2' color='textPrimary' component="h3" sx={{ textTransform: "capitalize" }}>
                                                {room.course_name ? room.course_name?.toLowerCase() : room.subject_name_short}
                                            </Typography>
                                        </Box>
                                        {UserStore?.getUser?.user_role !== 'STUDENT' && room.course_short_name && room.course_branch_short_name && <Typography fontWeight="400" fontSize="12px" component="span" sx={{ wordBreak: "break-all" }}>{`${room.course_short_name ? Array.from( new Set( room.course_short_name?.split( "," ) ) ).join( ", " ) : ""}-${( room.course_branch_short_name || "" )?.replace( /,/g, ", " )}`}</Typography>}
                                        {UserStore?.getUser?.user_role === 'STUDENT' && ( room?.presenter_name?.toLowerCase() || room?.employee_name?.toLowerCase() || room?.empID ) && <Typography display="flex" gap="5px" color="textSecondary" fontWeight="500" alignItems="center" noWrap fontSize="12px" sx={{}} textTransform="capitalize">{Icons.default.User} <em>{room?.presenter_name?.toLowerCase() || room?.employee_name?.toLowerCase() || room?.empID}</em></Typography>}

                                        {UserStore?.getUser?.user_role === 'STUDENT' && <Box display="flex" alignItems="center" flexWrap="wrap" gap="5px">
                                            <CustomChip tooltipTitle='Time interval' startIcon={Icons.default.Clock} value={room.intervals} />
                                            <CustomChip tooltipTitle='Interval type' value={room.interval_type_short} />
                                        </Box>}
                                        {UserStore?.getUser?.user_role !== 'STUDENT' && <Box display="flex" flexWrap="wrap" marginTop="2px" alignItems="center" fontSize="16px" sx={{}} gap="5px">
                                            <CustomChip tooltipTitle='Time interval' startIcon={Icons.default.Clock} value={room.intervals} />
                                            <CustomChip value={room.course_code} />
                                            <CustomChip value={room.batch_short_name !== 'NA' ? `Batch: ${room.batch_short_name}` : `Section: ${room.section_short_name}`} />
                                        </Box>}


                                        {( room.does_exists || room.online || ['faculty', 'hod', 'principal'].includes( UserStore.getUser.user_role.toLowerCase() ) || QuizStore.getClassQuizzes[room.time_table_id]?.length > 0 ) && <Box sx={{ transition: "all 200ms" }} overflow="hidden">
                                            <Divider sx={{ margin: "10px 0 5px 0" }} />
                                            <Box display="flex" flexWrap="wrap" justifyContent="flex-start" gap="5px">
                                                {
                                                    // room.room_status === 'online'
                                                    room?.status === 'on-going' && room?.empID === ( UserStore.getUser["empcode"] ?? "" ) && UserStore.getUser["user_role"] !== 'STUDENT' && ( room?.online || room.mode === "hybrid" ) &&
                                                    <ClassButton disabled={selectedDateDetails.tense?.isFuture || ending} disableElevation variant='contained' color="error" sx={{ minWidth: "initial", textTransform: "capitalize" }} size="small" onClick={( e ) => endSession( room )} >
                                                        {ending ? "Ending..." : "End"}
                                                    </ClassButton>
                                                }

                                                {/* STUDENT: SHOW JOIN BUTTON  */}
                                                {
                                                    !room?.does_exists &&
                                                    ( selectedDateDetails.tense?.isFuture || selectedDateDetails.tense?.isToday ) &&
                                                    room?.empID !== ( UserStore.getUser["empcode"] ?? "" ) && ( room?.online || room.mode === "hybrid" ) &&
                                                    <Button
                                                        disabled={selectedDateDetails.tense?.isFuture && !room.hybrid}
                                                        endIcon={room.mode === "hybrid" ? Icons.default.HybridClasses : Icons.default.Stream}
                                                        variant='contained'
                                                        disableElevation
                                                        sx={{ minWidth: "initial", textTransform: "capitalize" }}
                                                        size="small" onClick={( e ) => generateClassMeetingSessionAndStart( room )}
                                                    >
                                                        {room.mode === "hybrid" ? "View Class" : "Join Class"}
                                                    </Button>
                                                }

                                                {/* STUDENT: OPEN EXISTING CLASS */}
                                                {
                                                    room?.does_exists &&
                                                    room?.empID !== ( UserStore.getUser["empcode"] ?? "" ) && ( room?.online || room.mode === "hybrid" ) &&
                                                    <Button
                                                        disabled={selectedDateDetails.tense?.isFuture && !room.hybrid}
                                                        endIcon={room.mode === "hybrid" ? Icons.default.HybridClasses : Icons.default.Stream}
                                                        variant='contained'
                                                        disableElevation
                                                        sx={{ minWidth: "initial", textTransform: "capitalize" }}
                                                        size="small"
                                                        onClick={( e ) => generateClassMeetingSessionAndStart( room )}
                                                    >
                                                        {room.mode === "hybrid" ? "View Class" : "Join Class"}
                                                    </Button>
                                                }

                                                {/* FACULTY: OPEN EXISTING CLASS */}
                                                {
                                                    room?.does_exists &&
                                                    room?.empID === ( UserStore.getUser["empcode"] ?? "" ) &&
                                                    <Button
                                                        disabled={!room.hybrid && selectedDateDetails.tense?.isFuture}
                                                        endIcon={room?.does_exists?.meeting_type === 'hybrid-class' ? Icons.default.HybridClasses : Icons.default.Login}
                                                        variant='contained'
                                                        disableElevation
                                                        sx={{ minWidth: "initial", textTransform: "capitalize" }}
                                                        size="small"
                                                        onClick={( e ) => generateClassMeetingSessionAndStart( room )}
                                                    >
                                                        {room?.does_exists?.meeting_type === 'hybrid-class' ? "View Video Uploads" : ( selectedDateDetails.tense?.isFuture || selectedDateDetails.tense?.isToday ) ? "Join Class" : "View Class Details"}
                                                    </Button>
                                                }

                                                {/* FACULTY: START SCHEDULED CLASS */}
                                                {
                                                    // room?.room_status === 'online'
                                                    ( selectedDateDetails.tense?.isFuture || selectedDateDetails.tense?.isToday ) &&
                                                    !room?.does_exists && room?.empID === ( UserStore.getUser["empcode"] ?? "" ) && UserStore.getUser["user_role"] !== 'STUDENT' && ( room?.online || room.mode === "hybrid" ) &&
                                                    <Button
                                                        disabled={( selectedDateDetails.tense?.isFuture && !room.hybrid ) || checkingConflictForId === room.time_table_id}
                                                        variant='contained'
                                                        disableElevation
                                                        sx={{ minWidth: "initial", textTransform: "capitalize" }}
                                                        size="small"
                                                        color="primary"
                                                        onClick={( e ) => {
                                                            showStartClassOptions( room, false )
                                                        }}
                                                        startIcon={checkingConflictForId === room.time_table_id ? <CircularProgress size={14} /> : undefined}
                                                        endIcon={checkingConflictForId === room.time_table_id ? undefined : Icons.default.ChevronRightIcon}
                                                    >
                                                        {checkingConflictForId === room.time_table_id ? "Checking for conflicts..." : room.mode === "hybrid" ? "Choose Class Type to start" : "start class"}
                                                    </Button>
                                                }
                                                {( selectedDateDetails.tense?.isFuture || selectedDateDetails.tense?.isToday ) && ['faculty', 'hod', 'principal'].includes( UserStore.getUser.user_role.toLowerCase() ) && room && !QuizStore.getClassQuizzes[room.time_table_id]?.length && <Button
                                                    variant='outlined'
                                                    startIcon={Icons.default.QuizIconOutlined}
                                                    size='small'
                                                    disableElevation
                                                    color='secondary'
                                                    onClick={( e ) => { setRoomSelectedForQuiz( room ) }}
                                                >
                                                    Assign Quiz
                                                </Button>}
                                                {['faculty', 'hod', 'principal'].includes( UserStore.getUser.user_role.toLowerCase() ) && room && QuizStore.getClassQuizzes[room.time_table_id]?.length > 0 && QuizStore.getClassQuizzes[room.time_table_id]?.map( quiz => {
                                                    return <Tooltip key={quiz.id} title={quiz.title}>
                                                        <ClassButton key={quiz.id} sx={{ minWidth: "initial", textTransform: "capitalize" }} size="small" color="primary" onClick={( e ) => { navigate( `/faculty/quizzes/${quiz.quiz_id}?selectedQuizInstance=${quiz.id}` ) }} endIcon={Icons.default.QuizIconOutlined}>
                                                            Open quiz
                                                        </ClassButton>
                                                    </Tooltip>
                                                } )}
                                                {( selectedDateDetails.tense?.isFuture || selectedDateDetails.tense?.isToday ) && UserStore.getUser.user_role === 'STUDENT' && room && QuizStore.getClassQuizzes[room.time_table_id]?.length > 0 && QuizStore.getClassQuizzes[room.time_table_id]?.map( quiz => {
                                                    return <Tooltip key={quiz.id} title={quiz.title} >
                                                        <ClassButton sx={{ minWidth: "initial", textTransform: "capitalize" }} size="small" color="primary" onClick={( e ) => { navigate( `/student/quiz?quiz_id=${quiz.quiz_id}&instance_id=${quiz.id}` ) }} endIcon={Icons.default.QuizIconOutlined}>
                                                            Take Quiz
                                                        </ClassButton>
                                                    </Tooltip>
                                                } )}

                                                {/* {( selectedDateDetails.tense?.isFuture || selectedDateDetails.tense?.isToday ) && room?.status !== 'ended' && room?.does_exists === 0 && room?.empID === (UserStore.getUser["empcode"] ?? "") && room?.online &&
                                            <IconButton color="primary" disabled={selectedDateDetails.tense?.isFuture} onClick={( e ) => startSession( room, true )} aria-label="Start & Recording Session">
                                                {Icons.default.PlayCircleFilledWhiteIcon}
                                            </IconButton>
                                                                                } */}
                                            </Box>
                                        </Box>}

                                    </Box>
                                </Box>
                            )
                        } else {
                            return null
                        }
                    } )}
                </Box>}
                {!loading && sortedRooms?.filter( room => !room.meeting_type || ( room.meeting_type && !["class", "hybrid-class"].includes( room.meeting_type ) ) )?.length === 0 &&
                    <Box flexGrow={1} display="flex" alignItems="center" padding="20px" height="100%" flexDirection="column" gap="10px" justifyContent="center" >
                        <img src={noClassesImg} width="200px" alt="No classes" />
                        <Typography textAlign="center" marginTop="20px" variant="subtitle2" >{recentDays[selectedDateDetails.indianDisplayFormat] ? `No classes or meetings ${recentDays[selectedDateDetails.indianDisplayFormat]?.toLowerCase()}` : `No Classes or meetings scheduled for ${selectedDateDetails.cardDisplayFormat}`}</Typography>
                    </Box>}
                {loading && <Box flexGrow={1} display="flex" alignItems="center" padding="20px" height="100%" flexDirection="column" gap="10px" justifyContent="center" >
                    <DataLoadingSpinner waitingMessage='Loading classes...' />
                </Box>}
            </Card >

        </Box >
    )
}
)
export default ClassesCard